// extracted by mini-css-extract-plugin
export default {"icon":"Tooltip-module_icon__hEbU5","tooltip":"Tooltip-module_tooltip__kDF5M"};